import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import HelpMessage from "../Components/HelpMessage";
import SearchBar from "../Components/SearchBar";
import { useNavigate, useLocation } from "react-router-dom";

import { Document, Page } from 'react-pdf';

import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

const Charts = () => {
  const navigate = useNavigate();
  const [chartsData, setChartsData] = useState([]);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [currentPdf, setCurrentPdf] = useState(null);
  const [filesData, setFilesData] = useState(null);
  const [docWidth, setDocWidth] = useState(window.innerWidth * 0.9);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.4.168/pdf.worker.min.mjs';

  // on resize chagne doc width
  useEffect(() => {
    const handleResize = () => {
      setDocWidth(window.innerWidth * 0.9);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const showDocumentDetails = (document) => () => {
    let DocLink = document.Link;
    // Trim DocLink
    DocLink = DocLink.trim();

    setCurrentPdf(`${process.env.REACT_APP_API_BASEURL}/assets/documents/charts/${DocLink}.pdf`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_BASEURL + "/charts", {
          headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }
        });
        setChartsData(response.data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="" id="result-wrapper">
            <SearchBar/>

            {currentPdf ? <>
              <div className="uds-page-header">
                <a onClick={() => setCurrentPdf(null)} className="uds-page-header-icon"><i className="uicon-arrow-narrow-left"></i></a> <h1>Chart</h1>
              </div>
              <Document
                file={currentPdf}
                
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              >
                {/* For each page in the PDF, render a Page component */}
                {Array.from({ length: numPages }, (_, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} width={docWidth} />
                ))}
              </Document>

              <div className="uds-page-header uds-footer-back" onClick={() => setCurrentPdf(null)}>
                <div className="uds-page-header-icon"><i className="uicon-arrow-narrow-left"></i></div> <span>Back to Charts List</span>
              </div>

            </> : <>

              <div className="uds-page-header">
                <a onClick={() => navigate('/Home')} className="uds-page-header-icon"><i className="uicon-arrow-narrow-left"></i></a> <h1>Charts</h1>
              </div>

              <form className="login100-form validate-form" method="post">
                <div className="docs-list-wrapper">
                  <div className="docs-list">
                    <div className="docs-list-row docs-list-header">
                      <div className="docs-list-col">Chart</div>
                      <div className="docs-list-col">Date</div>
                    </div>

                    {chartsData
                      .slice()
                      .reverse()
                      .map((document) => (
                        <div className="docs-list-row docs-list-body" key={document.DocName} onClick={showDocumentDetails(document)}>
                          <div className="docs-list-col">{document.DocName}</div>
                          <div className="docs-list-col">{document.FullDate}</div>
                        </div>
                      ))}
                  </div>
                </div>
              </form>
            </>}
            
            <HelpMessage />
          </div>
        </div>
      </div>
    </>
  );
};

export default Charts;



